export default __webpack_public_path__ + "static/media/memories-Text.31792d39.png";